var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M4.667 9.667V1.333m0 8.334H1.333V1.333h3.334m0 8.334 4.33 5.05c.41.48 1.057.686 1.669.533l.04-.01a1.667 1.667 0 0 0 .982-2.541L9.667 9.667h3.8c1.052 0 1.84-.963 1.634-1.994l-1-5a1.67 1.67 0 0 0-1.634-1.34h-7.8"
  })));
};
export default SvgDislike;